import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import IndustriesPage from "./pages/IndustriesPage";
import IndustryDetailPage from "./pages/IndustryDetailPage";
import InsightsPage from "./pages/InsightsPage";
import InsightDetailPage from "./pages/InsightDetailPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import LocationPage from "./pages/LocationPage";
import GuidePage from "./pages/GuidePage";
import { PrivacyPolicyPage, TermsAndConditionsPage, CookiePolicyPage } from "./pages/LegalPages";
import BookingPage from "./pages/BookingPage";
import ContactPage from "./pages/ContactPage";
import RecommendPage from "./pages/RecommendPage";
import AdminPage from "./pages/AdminPage";
import OpisPage from "./pages/OpisPage";
import FoundingMembersPage from "./pages/FoundingMembersPage";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Layout>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/services/:slug" element={<ServiceDetailPage />} />
                        <Route path="/industries" element={<IndustriesPage />} />
                        <Route path="/industries/:slug" element={<IndustryDetailPage />} />
                        <Route path="/insights" element={<InsightsPage />} />
                        <Route path="/insights/:slug" element={<InsightDetailPage />} />
                        <Route path="/case-studies" element={<CaseStudiesPage />} />
                        <Route path="/hotel-consultancy-london" element={<LocationPage />} />
                        <Route path="/hospitality-consultant-uk" element={<LocationPage />} />
                        <Route path="/hospitality-business-consultant" element={<LocationPage />} />
                        <Route path="/hospitality-audit-guide" element={<GuidePage />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
                        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
                        <Route path="/booking" element={<BookingPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/recommend" element={<RecommendPage />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="/opis" element={<OpisPage />} />
                        <Route path="/opis/founding-members" element={<FoundingMembersPage />} />
                    </Routes>
                </Layout>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "#0B132B",
                            color: "#F9F8F6",
                            border: "1px solid #C5A880",
                            borderRadius: 0,
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
